module.exports = __webpack_public_path__ + "static/media/lock.03b7a5b4.svg";